import baseApi from '@/store/api/baseApi';

export const gmvTargetApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getGmvTargetOverview: builder.query({
			query: () => ({
				url: '/dashboard/gmv-target-overview',
				method: 'GET'
			})
		})
	})
});

export const { useGetGmvTargetOverviewQuery } = gmvTargetApi;
